export default "__VITE_ASSET__BVF9Jaeh__"